angular
    .module('AutoPrequal')
    .controller('resultsCtrl', resultsCtrl);

resultsCtrl.$inject = ['$scope', '$rootScope', 'DataFactory', '$filter', '$state', '$timeout'];

function resultsCtrl($scope, $rootScope, DataFactory, $filter, $state, $timeout) {

	function dataLayerPushloanAmount() {
		dataLayer.push({
			"event": "loanAmount",
			"category": "Auto Finance - Prequal",
			"action": $scope.calcdata.loanAmount,
			"label": $scope.calcdata.loanAmount
		})
    }

    if (!$rootScope.isLoaded) {
        $rootScope.currentStep = "welcome";
        $state.go('main', { 'hash': 'welcome' });
        return;
    }
    $scope.$on('$locationChangeStart', function (event, next, current) {
        if (next.indexOf('results') === -1) {
            $rootScope.forcedLoader = true;
            event.preventDefault();
            $rootScope.restart();
        }
    });
	


	

	$timeout(function () {
		
		$(".interestRate").text(incoming_lang == "fr" ? interestRate.toString().replace('.', ',') : interestRate);
		var interestRateElement = $("#interest-rate");
		if (interestRateElement.val() < 0.01) {
			var formatRate = interestRateElement.val() * 1200;
			interestRateElement.val(formatRate).change();
		}
		$('.loanTerm').text($scope.calcdata.loanTerm);
	}, 500);

	$timeout(function () {
		$('main').scrollTop(0);
		$rootScope.forcedLoader = false;
	});


    $rootScope.currentStep = "results";
    $rootScope.progressCurrent = 0;
    $rootScope.progressMobCurrent = 0;

	$scope.showOptionsModal = false;
	$scope.showPPModal = false;
    $scope.status = {};
    $scope.data = DataFactory.appData.applicant;
	$scope.result = DataFactory.appData.submit;
	$scope.approved = $scope.result.prequalResult === "Success";
    $scope.localContent = DataFactory.appData.content.results;
	$scope.openSliderModal = openSliderModal;
	$scope.tooltip_content = "";

	$scope.calcdata = angular.copy($scope.result);
	$scope.calcdata.downPayment = $scope.data.apDownPayment;
	$scope.calcdata.monthlyPayment = Math.floor($scope.calcdata.monthlyPayment);

	dataLayerPushloanAmount()
	

	$scope.updateInterestRate = updateInterestRate;
	$scope.updateLoanTerm = updateLoanTerm;
	$scope.updateMonthlyPayment = updateMonthlyPayment;
	$scope.updateDownPayment = updateDownPayment;
	$scope.adjustLoanTerm = adjustLoanTerm;
	$scope.expandSliders = false;
	$scope.minLoanError = false;
	$scope.termRead = false;

	

	$scope.$watch('showPPModal', function (newVal, oldVal) {
		if (newVal !== oldVal && !newVal) $timeout(function () { jQuery('#pp-modal-btn').focus(); });
	});

	$scope.$watch('expandSliders', function (newVal, oldVal) {
		if (newVal !== oldVal && newVal) $timeout(function () { jQuery('#tipLoanTerm').focus(); });
	});

	$scope.$watch('showOptionsModal', function (newVal, oldVal) {
		if (newVal !== oldVal && !newVal) $timeout(function () { jQuery('#open-slider-modal-btn').focus(); });
	});

	function recalculate(lt, mp) {
		var intRate = ($scope.calcdata.interestRate === 0 ? 0.001 : $scope.calcdata.interestRate) / 1200 ;
		var loanAmount = mp / ((intRate * Math.pow(1 + +intRate, lt)) / (Math.pow(1 + +intRate, lt) - 1));
		if (loanAmount < 7500) {
			$scope.minLoanError = true;
		}
		else {
			$scope.minLoanError = false;
			$scope.calcdata.loanAmount = loanAmount;
			calculatePurchasePrice();
		}
	}

	function calculatePurchasePrice() {	
		$scope.calcdata.purchasePrice = +$scope.calcdata.netTradeinValue + +$scope.calcdata.loanAmount + +$scope.calcdata.downPayment;
		dataLayerPushloanAmount()
	}

    $timeout(function () {
        //focus on title after animation is done
        $('h1:visible')[0].focus();
    }, 500)

	function openSliderModal() {
		var el = jQuery("#monthly-payment-wpr");
		var offset = el.offset().top - (window.innerHeight / 2);
		$scope.showOptionsModal = true;
		$timeout(function () {
			jQuery("main").scrollTop(offset);
			jQuery("#tipLoanTermMob").focus();
		}, 300);
	}

	function formatSliderCurrency(input) {
		return $filter('currency')(input);
	}

	$scope.MIN_MONTHLY_PAYMENT = 118;
	$scope.MAX_DOWN_PAYMENT = +$scope.calcdata.downPayment + +25000;
	var mpValues = getMonthlyPaymentValues();

	var ir_slider = jQuery('#interestRate-slider');
	var $ir_minLabel = ir_slider.closest('.slider-container').find("#min-label");
	var $ir_maxLabel = ir_slider.closest('.slider-container').find("#max-label");

	ir_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		min: 0,
		max: 14.99,
		postfix: $scope.localContent.percentage,
		from: $scope.calcdata.interestRate,
		step: 0.50,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$ir_minLabel.text(res.min + $scope.localContent.percentage);
			$ir_maxLabel.text((incoming_lang == "fr" ? res.max.toString().replace('.', ',') : res.max) + $scope.localContent.percentage);
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateIRSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () {
				$scope.calcdata.interestRate = Number(res.from);
				$(".interestRate").text(incoming_lang == "fr" ? $scope.calcdata.interestRate.toString().replace('.', ',') : $scope.calcdata.interestRate);
			});

			irmob_slider_instance.update({ from: res.from });
			updateInterestRateA11y();
			$timeout(function () { recalculate($scope.calcdata.loanTerm, $scope.calcdata.monthlyPayment); });
		}
	});

	var irmob_slider = jQuery('#interestRateMob-slider');
	var $ir_minLabelMob = irmob_slider.closest('.slider-container').find("#min-label");
	var $ir_maxLabelMob = irmob_slider.closest('.slider-container').find("#max-label");

	irmob_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		min: 0,
		max: 14.99,
		postfix: $scope.localContent.percentage,
		from: $scope.calcdata.interestRate,
		step: 0.50,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$ir_minLabelMob.text(res.min + $scope.localContent.percentage);
			$ir_maxLabelMob.text((incoming_lang == "fr" ? res.max.toString().replace('.', ',') : res.max) + $scope.localContent.percentage);
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateIRSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () {
				$scope.calcdata.interestRate = Number(res.from);
				$(".interestRate").text(incoming_lang == "fr" ? $scope.calcdata.interestRate.toString().replace('.', ',') : $scope.calcdata.interestRate);
				
			});
			ir_slider_instance.update({ from: res.from });
			updateInterestRateA11y();
			$timeout(function () { recalculate($scope.calcdata.loanTerm, $scope.calcdata.monthlyPayment); });
		}
	});

	var ir_slider_instance = ir_slider.data("ionRangeSlider");
	var irmob_slider_instance = irmob_slider.data("ionRangeSlider");
	updateInterestRateA11y();

	var lt_slider = jQuery('#loanTerm-slider');
	var $lt_minLabel = lt_slider.closest('.slider-container').find("#min-label");
	var $lt_maxLabel = lt_slider.closest('.slider-container').find("#max-label");

	lt_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		min: 12,
		max: 96,
		postfix: $scope.localContent.months,
		from: $scope.calcdata.loanTerm,
		step: 12,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$lt_minLabel.text(res.min + $scope.localContent.months);
			$lt_maxLabel.text(res.max + $scope.localContent.months);
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateLTSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () {
				$scope.calcdata.loanTerm = res.from;
				$('.loanTerm').text($scope.calcdata.loanTerm);
			});

			ltmob_slider_instance.update({ from: res.from });
			updateLoanTermA11y();
			$timeout(function () { recalculate(res.from, $scope.calcdata.monthlyPayment); });
		}
	});

	var ltmob_slider = jQuery('#loanTermMob-slider');
	var $lt_minLabelMob = ltmob_slider.closest('.slider-container').find("#min-label");
	var $lt_maxLabelMob = ltmob_slider.closest('.slider-container').find("#max-label");

	ltmob_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		min: 12,
		max: 96,
		postfix: $scope.localContent.months,
		from: $scope.calcdata.loanTerm,
		step: 12,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$lt_minLabelMob.text(res.min + $scope.localContent.months);
			$lt_maxLabelMob.text(res.max + $scope.localContent.months);
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateLTSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () {
				$scope.calcdata.loanTerm = res.from;
				$('.loanTerm').text($scope.calcdata.loanTerm);
			});
			lt_slider_instance.update({ from: res.from });
			updateLoanTermA11y();
			$timeout(function () { recalculate(res.from, $scope.calcdata.monthlyPayment); });
		}
	});

	var lt_slider_instance = lt_slider.data("ionRangeSlider");
	var ltmob_slider_instance = ltmob_slider.data("ionRangeSlider");
	updateLoanTermA11y();

	var mp_slider = jQuery('#monthlyPayments-slider');
	var $mp_minLabel = mp_slider.closest('.slider-container').find("#min-label");
	var $mp_maxLabel = mp_slider.closest('.slider-container').find("#max-label");

	mp_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		from: mpValues.length - 1,
		values: mpValues,
		prettify_enabled: true,
		prettify: formatSliderCurrency,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$mp_minLabel.text(incoming_lang == "fr" ? mpValues.at(0) + " $" : "$" + mpValues.at(0));
			$mp_maxLabel.text(incoming_lang == "fr" ? mpValues.at(-1) + " $" : "$" + mpValues.at(-1));
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateMPSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () { $scope.calcdata.monthlyPayment = mpValues[res.from] });
			mpmob_slider_instance.update({ from: res.from });
			updateMonthlyPaymentA11y();
			$timeout(function () { recalculate($scope.calcdata.loanTerm, mpValues[res.from]); });
		}
	});

	var mpmob_slider = jQuery('#monthlyPaymentsMob-slider');
	var $mp_minLabelMob = mpmob_slider.closest('.slider-container').find("#min-label");
	var $mp_maxLabelMob = mpmob_slider.closest('.slider-container').find("#max-label");

	mpmob_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		from: mpValues.length - 1,
		values: mpValues,
		prettify_enabled: true,
		prettify: formatSliderCurrency,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$mp_minLabelMob.text(incoming_lang == "fr" ? mpValues.at(0) + " $" : "$" + mpValues.at(0));
			$mp_maxLabelMob.text(incoming_lang == "fr" ? mpValues.at(-1) + " $" : "$" + mpValues.at(-1));
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateMPSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () { $scope.calcdata.monthlyPayment = mpValues[res.from] });
			mp_slider_instance.update({ from: res.from });
			updateMonthlyPaymentA11y();
			$timeout(function () { recalculate($scope.calcdata.loanTerm, mpValues[res.from]); });
		}
	});

	var mp_slider_instance = mp_slider.data("ionRangeSlider");
	var mpmob_slider_instance = mpmob_slider.data("ionRangeSlider");
	updateMonthlyPaymentA11y();

	var dp_slider = jQuery('#downPayment-slider');
	var $dp_minLabel = dp_slider.closest('.slider-container').find("#min-label");
	var $dp_maxLabel = dp_slider.closest('.slider-container').find("#max-label");

	dp_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		min: 0,
		max: $scope.MAX_DOWN_PAYMENT,
		prettify_enabled: true,
		prettify: formatSliderCurrency,
		from: $scope.calcdata.downPayment,
		step: 100,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$dp_minLabel.text(formatSliderCurrency(res.min));
			$dp_maxLabel.text(formatSliderCurrency(res.max));
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateDPSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () { $scope.calcdata.downPayment = res.from });
			dpmob_slider_instance.update({ from: res.from });
			updateDownPaymentA11y();
			$timeout(function () { calculatePurchasePrice(); });
			$scope.ResultOptions["down-payment"].$setValidity('', true);
			$scope.ResultOptionsMob["down-payment"].$setValidity('', true);
		}
	});

	var dpmob_slider = jQuery('#downPaymentMob-slider');
	var $dp_minLabelMob = dpmob_slider.closest('.slider-container').find("#min-label");
	var $dp_maxLabelMob = dpmob_slider.closest('.slider-container').find("#max-label");

	dpmob_slider.ionRangeSlider({
		type: "single",
		skin: "round",
		min: 0,
		max: $scope.MAX_DOWN_PAYMENT,
		prettify_enabled: true,
		prettify: formatSliderCurrency,
		from: $scope.calcdata.downPayment,
		step: 100,
		hide_min_max: true,
		grid_snap: false,
		onStart: function (res) {
			$dp_minLabelMob.text(formatSliderCurrency(res.min));
			$dp_maxLabelMob.text(formatSliderCurrency(res.max));
		},
		onUpdate: function (res) {},
		onFinish: function (res) {
			$rootScope.ga.updateDPSlider();
		},
		onChange: function (res) {
			$scope.$apply(function () { $scope.calcdata.downPayment = res.from });
			dp_slider_instance.update({ from: res.from });
			updateDownPaymentA11y();
			$timeout(function () { calculatePurchasePrice(); });
			$scope.ResultOptions["down-payment"].$setValidity('', true);
			$scope.ResultOptionsMob["down-payment"].$setValidity('', true);
		}
	});

	var dp_slider_instance = dp_slider.data("ionRangeSlider");
	var dpmob_slider_instance = dpmob_slider.data("ionRangeSlider");
	updateDownPaymentA11y();

	function updateInterestRate() {
		var ir = $scope.calcdata.interestRate;
		if (isNaN(ir) || ir < 0 || ir > 14.99) {
			$scope.ResultOptions["interest-rate"].$setValidity('', false);
			$scope.ResultOptionsMob["interest-rate"].$setValidity('', false);
		}
		else {
			$scope.ResultOptions["interest-rate"].$setValidity('', true);
			$scope.ResultOptionsMob["interest-rate"].$setValidity('', true);
		} 

		if ($scope.ResultOptions.$valid && $scope.ResultOptionsMob.$valid) {
			ir_slider_instance.update({ from: ir });
			irmob_slider_instance.update({ from: ir });
			updateInterestRateA11y();
			$timeout(function () {
				recalculate($scope.calcdata.loanTerm, $scope.calcdata.monthlyPayment);
				$(".interestRate").text(incoming_lang == "fr" ? $scope.calcdata.interestRate.toString().replace('.', ',') : $scope.calcdata.interestRate);
			});
		}
	}

	function updateLoanTerm() {
		var lt = $scope.calcdata.loanTerm;
		if (isNaN(lt) || lt < 12 || lt > 96) {
			$scope.ResultOptions["loan-term"].$setValidity('', false);
			$scope.ResultOptionsMob["loan-term"].$setValidity('', false);
		}
		else {
			$scope.ResultOptions["loan-term"].$setValidity('', true);
			$scope.ResultOptionsMob["loan-term"].$setValidity('', true);
		} 

		if ($scope.ResultOptions.$valid && $scope.ResultOptionsMob.$valid) {
			lt_slider_instance.update({ from: lt });
			ltmob_slider_instance.update({ from: lt });
			updateLoanTermA11y();
			$timeout(function () {
				recalculate(lt, $scope.calcdata.monthlyPayment);

			});
		}
	}

	function updateMonthlyPayment() {
		var mp = $scope.calcdata.monthlyPayment;
		if (isNaN(mp) || mp < $scope.MIN_MONTHLY_PAYMENT || mp > $scope.result.monthlyPayment) {
			$scope.ResultOptions["monthly-payments"].$setValidity('', false);
			$scope.ResultOptionsMob["monthly-payments"].$setValidity('', false);
		}
		else {
			$scope.ResultOptions["monthly-payments"].$setValidity('', true);
			$scope.ResultOptionsMob["monthly-payments"].$setValidity('', true);
		}
		if ($scope.ResultOptions.$valid && $scope.ResultOptionsMob.$valid) {
			var closestVal = mpValues.indexOf(Math.round(+mp / 10) * 10);
			mp_slider_instance.update({ from: closestVal });
			mpmob_slider_instance.update({ from: closestVal });
			updateMonthlyPaymentA11y();
			$timeout(function () {
				recalculate($scope.calcdata.loanTerm, mp);
			});
		}
	}

	function updateDownPayment() {
		var dp = $scope.calcdata.downPayment;
		if (isNaN(dp) || dp < 0 || dp > $scope.MAX_DOWN_PAYMENT) {
			$scope.ResultOptions["down-payment"].$setValidity('', false);
			$scope.ResultOptionsMob["down-payment"].$setValidity('', false);
		}
		else {
			$scope.ResultOptions["down-payment"].$setValidity('', true);
			$scope.ResultOptionsMob["down-payment"].$setValidity('', true);
		}
		if ($scope.ResultOptions.$valid && $scope.ResultOptionsMob.$valid) {
			dp_slider_instance.update({ from: dp });
			dpmob_slider_instance.update({ from: dp });
			updateDownPaymentA11y();
			$timeout(function () {
				calculatePurchasePrice();
			});
		}
	}

	function updateInterestRateA11y() {
		$timeout(function () {
			var ir_slider_a11y = ir_slider.siblings('.irs').find('.irs-line');
			var irmob_slider_a11y = irmob_slider.siblings('.irs').find('.irs-line');
			ir_slider_a11y.attr('aria-valuemin', '0 ' + $scope.localContent.percentage);
			ir_slider_a11y.attr('aria-valuemax', '14.99 ' + $scope.localContent.percentage);
			ir_slider_a11y.attr('aria-valuetext', $scope.calcdata.interestRate + ' ' + $scope.localContent.percentage);
			irmob_slider_a11y.attr('aria-valuemin', '0 ' + $scope.localContent.percentage);
			irmob_slider_a11y.attr('aria-valuemax', '14.99 ' + $scope.localContent.percentage);
			irmob_slider_a11y.attr('aria-valuetext', $scope.calcdata.interestRate + ' ' + $scope.localContent.percentage);
		});
	}

	function updateLoanTermA11y() {
		$timeout(function () {
			var lt_slider_a11y = lt_slider.siblings('.irs').find('.irs-line');
			var ltmob_slider_a11y = ltmob_slider.siblings('.irs').find('.irs-line');
			lt_slider_a11y.attr('aria-valuemin', '12 ' + $scope.localContent.months);
			lt_slider_a11y.attr('aria-valuemax', '96 ' + $scope.localContent.months);
			lt_slider_a11y.attr('aria-valuetext', $scope.calcdata.loanTerm + ' ' + $scope.localContent.months);
			ltmob_slider_a11y.attr('aria-valuemin', '12 ' + $scope.localContent.months);
			ltmob_slider_a11y.attr('aria-valuemax', '96 ' + $scope.localContent.months);
			ltmob_slider_a11y.attr('aria-valuetext', $scope.calcdata.loanTerm + ' ' + $scope.localContent.months);
		});
	}

	function updateMonthlyPaymentA11y() {
		$timeout(function () {
			var mp_slider_a11y = mp_slider.siblings('.irs').find('.irs-line');
			var mpmob_slider_a11y = mpmob_slider.siblings('.irs').find('.irs-line');
			mp_slider_a11y.attr('aria-valuemin', $filter('currency')($scope.MIN_MONTHLY_PAYMENT));
			mp_slider_a11y.attr('aria-valuemax', $filter('currency')($scope.result.monthlyPayment));
			mp_slider_a11y.attr('aria-valuetext', $filter('currency')($scope.calcdata.monthlyPayment));
			mpmob_slider_a11y.attr('aria-valuemin', $filter('currency')($scope.MIN_MONTHLY_PAYMENT));
			mpmob_slider_a11y.attr('aria-valuemax', $filter('currency')($scope.result.monthlyPayment));
			mpmob_slider_a11y.attr('aria-valuetext', $filter('currency')($scope.calcdata.monthlyPayment));
		});
	}

	function updateDownPaymentA11y() {
		$timeout(function () {
			var dp_slider_a11y = dp_slider.siblings('.irs').find('.irs-line');
			var dpmob_slider_a11y = dpmob_slider.siblings('.irs').find('.irs-line');
			dp_slider_a11y.attr('aria-valuemin', $filter('currency')(0));
			dp_slider_a11y.attr('aria-valuemax', $filter('currency')($scope.MAX_DOWN_PAYMENT));
			dp_slider_a11y.attr('aria-valuetext', $filter('currency')($scope.calcdata.downPayment));
			dpmob_slider_a11y.attr('aria-valuemin', $filter('currency')(0));
			dpmob_slider_a11y.attr('aria-valuemax', $filter('currency')($scope.MAX_DOWN_PAYMENT));
			dpmob_slider_a11y.attr('aria-valuetext', $filter('currency')($scope.calcdata.downPayment));
		});
	}

	function adjustLoanTerm() {
		$scope.calcdata.loanTerm = Math.round(+$scope.calcdata.loanTerm / 12) * 12;
		updateLoanTerm();
	}

	function getMonthlyPaymentValues() {
		var rVal = [];
		rVal.push($scope.MIN_MONTHLY_PAYMENT);
		for (var i = 120; i < $scope.calcdata.monthlyPayment; i += 10) {
			rVal.push(i);
		}
		rVal.push($scope.calcdata.monthlyPayment);
		return rVal;
	}
}